import { ID, ImagePreviewType } from "@nova/constants"
import { RootState } from "integrations/redux"
import { root } from "./module"
import { GroupedLayerVisibilityMaps } from "./types"
import { createSelector } from "@reduxjs/toolkit"
import { selectAllEntitiesMap } from "panels/content/side-panel/slice"
import { getAncestors } from "panels/content/side-panel/utils"

export const selectShowLayerByIdMapForHotspotOrthoOverlaps = (state: RootState) =>
    root(state).show.hotspotOrthoOverlaps

export const selectHotspotOrthoOverlapIsEnabled = (id: ID) => (state: RootState) =>
    root(state).show.hotspotOrthoOverlaps[id]

export const selectHiddenLayerIds = (
    entitySelector: (state: RootState) => Record<string, { visible?: boolean }>
) =>
    createSelector([entitySelector, selectAllEntitiesMap], (entities, entityMap) => {
        const hidden: ID[] = []
        Object.entries(entities).forEach(([id, entity]) => {
            const ancestors = getAncestors(id, entityMap)
            if (!entity.visible || ancestors.find((ancestor) => !ancestor.visible)) hidden.push(id)
        })
        return hidden
    })

export const selectActiveShowMaps = (state: RootState): GroupedLayerVisibilityMaps =>
    root(state).show
export const selectShowMapsFromHistory =
    (fireId: string) =>
    (state: RootState): GroupedLayerVisibilityMaps | undefined =>
        root(state).history.show[fireId]

export const selectPreviewedFlightIds = (state: RootState): string[] => {
    //only these four layers make up the bounding box:
    const layers = ["hotspotPoints", "hotspotOrthos", "hotspotPolygons", "flightPath"]
    const preview = root(state).preview as Record<string, Record<string, boolean>>
    if (!preview) return []

    const result: string[] = []
    Object.entries(preview).forEach(([layerName, ids]) => {
        if (!layers.includes(layerName)) {
            return
        }
        Object.entries(ids).forEach(([id, preview]) => {
            if (preview) result.push(id)
        })
    })
    return result
}

export const selectPreviewLayerByIdMapForHotspotPoints = (state: RootState) =>
    root(state).preview.hotspotPoints

export const selectPreviewLayerByIdMapForFlightPath = (state: RootState) =>
    root(state).preview.flightPath

export const selectPreviewLayerByIdMapForHotspotOrthos = (state: RootState) =>
    root(state).preview.hotspotOrthos

export const selectPreviewLayerByIdMapForHotspotPolygons = (state: RootState) =>
    root(state).preview.hotspotPolygons

export const selectHoveredTextElementId = (state: RootState) => root(state).hoveredTextElementId
export const selectActiveImageIds = (state: RootState) =>
    root(state).activeImageIds as Record<string, boolean>
export const selectHoveredImageID = (state: RootState) =>
    root(state).hoveredImageId as ID | undefined

export const selectUploadTimestampForFlightId = (id: string) => (state: RootState) =>
    root(state).uploadTimestamps?.[id] as string | undefined

export const selectImagePreviewContext = () => (state: RootState) =>
    root(state).imagePreviewContext as { id: string; type: ImagePreviewType } | undefined
